<template>
  <div class="liveness container">
    <div class="top">
      <div class="code">
        <div class="code-title">
          <span>请牢记以下验证码</span>
        </div>
        <div class="code-top">
          <span>用普通话朗读，视频时长3-8秒最佳</span>
        </div>
        <div class="code-code">
          <div class="code-text" v-for="(item, index) in codeArr" :key="index">
            <span>{{ item }}</span>
          </div>
        </div>
        <div class="code-tips">
          <span>请正视手机，保证光线充足</span>
        </div>
        <div class="code-tips">
          <span>请勿遮挡面部</span>
        </div>
      </div>
    </div>
    <div class="text">
      <div>
        <span>①.牢记验证码，点击开始录制</span>
      </div>
      <div>
        <span>②.开启前置摄像头，用普通话朗读数字</span>
      </div>
      <div>
        <span>③.完成录制，等待验证结果</span>
      </div>
    </div>
    <div class="button-list">
      <mt-button type="primary" size="large" @click="handleStartTap">开始录制</mt-button>
    </div>
    <input id="video1" style="display: none;" type="file" accept="video/*" capture="camcorder"
      @change="handleFileChange" />
  </div>
</template>

<script>
import { MessageBox, Indicator } from 'mint-ui';
import { upLoadImg } from '@/utils/utils';
import { CusToast } from '@/utils/CustomToast';
import { mapMutations } from 'vuex';

export default {
  name: 'Liveness',
  data() {
    return {
      code: '',
      codeArr: [],
      session_id: '',
      access_token: '',
      mobile: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.mobile = this.$route.query.mobile;
      this.access_token = this.$route.query.accesstoken;
    });
  },
  methods: {
    ...mapMutations(['setLivingFaceImgUrl', 'setLivingFacePopupStatus']),
    drawBaiduSessionCode() {
      // 人脸识别次数计数
      const mobile = this.$route.query.mobile || 99999999999;
      const faceCount = window.sessionStorage.getItem(`${mobile}_facecount`);
      // 识别次数未达上限
      Indicator.open('加载中...');
      this.$axios({
        url: `https://aip.baidubce.com/rest/2.0/face/v1/faceliveness/sessioncode?access_token=${this.access_token}`,
        data: 'min_code_length=4&max_code_length=4',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
        .then(res => {
          Indicator.close();
          if (res.data.error_code === 0) {
            this.code = res.data.result.code;
            this.codeArr = res.data.result.code.split('');
            this.session_id = res.data.result.session_id;
            window.sessionStorage.setItem(`${mobile}_facecount`, faceCount - 0 + 1);
          } else {
            MessageBox({
              title: '提示',
              message: res.data.error_msg,
            });
          }
        })
        .catch();
    },
    handleStartTap() {
      document.getElementById('video1').click();
    },
    handleFileChange(e) {
      const that = this;
      if (!e.target.value) return;
      Indicator.open('人脸识别进行中…');
      const file = document.getElementById('video1').files[0];
      const reader = new FileReader();
      reader.onload = function () {
        const formData = new FormData();
        formData.append('session_id', that.session_id);
        formData.append('video_base64', this.result.split(',')[1]);
        that
          .$axios({
            url: `https://aip.baidubce.com/rest/2.0/face/v1/faceliveness/verify?access_token=${that.access_token}`,
            data: formData,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(res => {
            Indicator.close();
            if (res.data.error_code === 0) {
              // console.log(res.data.result);
              const score = res.data.result.score; // 活体分数
              const thresholds = res.data.result.thresholds['frr_1e-3']; // 活体阈值
              const similarity = res.data.result.code.similarity; // 语音相似度
              const condition1 = score > thresholds; // 合格条件1：活体分数大于阈值，合格
              const condition2 = similarity > 0.75; // 合格条件2：语音相似度大于0.75，合格
              if (condition1 && condition2) {
                const pic = res.data.result.pic_list[0].pic;
                upLoadImg(
                  null,
                  pic,
                  'renLian',
                  this.mobile,
                  res => {
                    Indicator.close();
                    if (res.code === 0) {
                      CusToast('人脸识别成功');
                      that.setLivingFaceImgUrl(res.data);
                      that.setLivingFacePopupStatus(false);
                    } else {
                      CusToast('图片上传失败');
                    }
                  },
                  () => Indicator.close()
                );
              } else {
                if (!condition1) {
                  MessageBox({
                    title: '提示',
                    message: `分数:${score}，阈值:${thresholds}，分数小于阈值，不合格，请重新录制视频`,
                  }).then(() => that.drawBaiduSessionCode());
                }
                if (!condition2) {
                  MessageBox({
                    title: '提示',
                    message: `语音相似度:${similarity}，小于0.75，不合格，请重新录制视频`,
                  }).then(() => that.drawBaiduSessionCode());
                }
              }
            } else {
              that.showFaceFailInfo(res.data.error_code);
            }
          })
          .catch(err => {
            Indicator.close();
            MessageBox({
              title: '提示',
              message: err.errMsg,
            });
          });
      };
      reader.readAsDataURL(file);
    },

    showFaceFailInfo(errCode) {
      let content = '';
      switch (errCode) {
        case 216430:
          content = 'rtse/face 服务异常，请重新录制视频';
          break;
        case 216431:
          content = '语音识别服务异常，请重新录制视频';
          break;
        case 216432:
          content = '视频解析服务调用失败，请重新录制视频';
          break;
        case 216433:
          content = '视频解析服务发生错误，请重新录制视频';
          break;
        case 216434:
          content = '活体检测失败，请重新录制视频';
          break;
        case 216500:
          content = '验证码位数错误，请重新录制视频';
          break;
        case 216501:
          content = '没有找到人脸，请重新录制视频';
          break;
        case 216502:
          content = '当前会话已失效，请重新录制视频';
          break;
        case 216505:
          content = 'redis连接失败，请重新录制视频';
          break;
        case 216506:
          content = 'redis操作失败，请重新录制视频';
          break;
        case 216507:
          content = '视频中有多张人脸，请重新录制视频';
          break;
        case 216508:
          content = '没有找到视频信息，请重新录制视频';
          break;
        case 216509:
          content = '视频中的声音无法识别，请重新录制视频';
          break;
        case 216908:
          content = '视频中人脸质量过低，请重新录制视频';
          break;
        case 222027:
          content = '验证码长度错误，请重新录制视频';
          break;
        case 222028:
          content = '参数格式错误，请重新录制视频';
          break;
        case 222029:
          content = '参数格式错误，请重新录制视频';
          break;
        case 222030:
          content = '参数格式错误，请重新录制视频';
          break;
        default:
          content = `错误，错误码${errCode}，请重新录制视频`;
          break;
      }
      MessageBox({
        title: '提示',
        message: `${content}`,
        showCancel: false,
      }).then(() => this.drawBaiduSessionCode());
    },
  },
};
</script>
